export const SaveIcon = () => {
  return (
    <img
      alt="save-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/save.svg"}
    />
  );
};

export const SearchIcon = () => {
  return (
    <img
      alt="Search-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/Search.svg"}
    />
  );
};

export const Undo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#clip0_2109_2889)">
        <path d="M7.50033 11.6667L4.16699 8.33333L7.50033 5" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M4.16699 8.33203H13.3337C14.2177 8.33203 15.0656 8.68322 15.6907 9.30834C16.3158 9.93346 16.667 10.7813 16.667 11.6654C16.667 12.5494 16.3158 13.3973 15.6907 14.0224C15.0656 14.6475 14.2177 14.9987 13.3337 14.9987H12.5003" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2109_2889">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const Redo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#clip0_2000_3718)">
        <path d="M12.4997 11.6667L15.833 8.33333L12.4997 5" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15.833 8.33203H6.66634C5.78229 8.33203 4.93444 8.68322 4.30932 9.30834C3.6842 9.93346 3.33301 10.7813 3.33301 11.6654C3.33301 12.5494 3.6842 13.3973 4.30932 14.0224C4.93444 14.6475 5.78229 14.9987 6.66634 14.9987H7.49967" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2000_3718">
          <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0)" />
        </clipPath>
      </defs>
    </svg>

  )
}


export const Langchange = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 19h16" />
      <path d="M12 3v16" />
      <path d="M16 11V3l-4 8" />
      <path d="M8 11V3l4 8" />
      <polyline points="16 15 18 17 22 13" />
    </svg>


  )
}


export const ReplaceIcon = () => {
  return (
    <img
      alt="Replace-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/Replace.svg"}
    />
  );
};

export const MathEqn = () => {
  return (
    <img
      alt="Matheqn-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/MathEqn.svg"}
    />
  );
};

export const RefreshIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-clipboard-list"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" /><path d="M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2" /><path d="M9 12l.01 0" /><path d="M13 12l2 0" /><path d="M9 16l.01 0" /><path d="M13 16l2 0" /></svg>
  )
}



export const BoldIcon = () => {
  return (
    <img
      alt="Bold-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/BoldIcon.svg"}
    />
  );
};

export const ItalicIcon = () => {
  return (
    <img
      alt="Italic-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/ItalicsIcon.svg"}
    />
  );
};

export const ShowChange = () => {
  return (
    <img
      alt="howchanges"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/showtrackchange.svg"}
    />
  );
};

export const HideChange = () => {
  return (
    <img
      alt="Hidechanges"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/hidetrackchange.svg"}
    />
  );
};

export const Auto = () => {
  return (
    <img
      alt="Autocorrect-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/AutoCorrectIcon.svg"}
    />
  );
};

export const Resize1 = () => {
  return (
    <img
      alt="Resize-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/Resize1.svg"}
    />
  );
};

export const Resize2 = () => {
  return (
    <img
      alt="Resize-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/Resize2.svg"}
    />
  );
};

export const MenuBar = () => {
  return (
    // <img
    //   alt="Resize-icon"
    //   src={process.env.PUBLIC_URL + "/images/Redesignpics/MenuBar.svg"}
    // />
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M3.33301 5H16.6663"
        stroke="#FFFFFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33301 10H16.6663"
        stroke="#FFFFFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33301 15H16.6663"
        stroke="#FFFFFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MenuClose = () => {
  return (
    // <img
    //   alt="Resize-icon"
    //   src={process.env.PUBLIC_URL + "/images/Redesignpics/closeIcon.svg"}
    // />
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M5 5L15 15M15 5L5 15"
        stroke="#FFFFFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ZoomOut = () => {
  return (
    <img
      alt="Resize-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/zoomOut.svg"}
    />
  );
};

export const ZoomIn = () => {
  return (
    <img
      alt="Resize-icon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/zoomIn.svg"}
    />
  );
};

export const TwoPage = () => {
  return (
    <img
      alt="twopageicon"
      src={process.env.PUBLIC_URL + "/images/Redesignpics/twoPageview.svg"}
    />
  );
};

